<div class="admin-dashboard">
  <div class="dashboard-hero">
    <div>
      <p class="eyebrow">{{ 'ADMIN_DASHBOARD.EYEBROW' | translate }}</p>
      <h1>{{ 'ADMIN_DASHBOARD.TITLE' | translate }}</h1>
      <p class="subtitle">{{ 'ADMIN_DASHBOARD.SUBTITLE' | translate }}</p>
    </div>
  </div>

  <nz-alert
    *ngIf="errorMessage"
    nzType="error"
    [nzMessage]="errorMessage"
    nzShowIcon
    class="dashboard-alert">
  </nz-alert>

  <nz-card class="filter-card">
    <form nz-form [formGroup]="filtersForm" class="filter-grid">
      <div class="filter-item filter-item--wide">
        <label>{{ 'ADMIN_DASHBOARD.FILTERS.ANALYSIS_PERIOD' | translate }}</label>
        <nz-range-picker formControlName="dateRange"></nz-range-picker>
      </div>

      <div class="filter-item">
        <label>{{ 'ADMIN_DASHBOARD.FILTERS.PLAN' | translate }}</label>
        <nz-select formControlName="plan">
          <nz-option *ngFor="let plan of planOptions" [nzValue]="plan" [nzLabel]="('ADMIN_DASHBOARD.FILTERS.' + plan.toUpperCase()) | translate"></nz-option>
        </nz-select>
      </div>

      <div class="filter-item">
        <label>{{ 'ADMIN_DASHBOARD.FILTERS.CONTRACT_STATUS' | translate }}</label>
        <nz-select formControlName="contractStatus">
          <nz-option *ngFor="let status of contractStatusOptions" [nzValue]="status" [nzLabel]="('ADMIN_DASHBOARD.CONTRACT_STATUS.' + status.toUpperCase()) | translate"></nz-option>
        </nz-select>
      </div>

      <div class="filter-item">
        <label>{{ 'ADMIN_DASHBOARD.FILTERS.COMPANY_STATUS' | translate }}</label>
        <nz-select formControlName="companyStatus">
          <nz-option *ngFor="let status of companyStatusOptions" [nzValue]="status" [nzLabel]="('ADMIN_DASHBOARD.FILTERS.' + status.toUpperCase()) | translate"></nz-option>
        </nz-select>
      </div>

      <div class="filter-item filter-item--toggle">
        <label>{{ 'ADMIN_DASHBOARD.FILTERS.EXCLUDE_TEST' | translate }}</label>
        <nz-switch formControlName="excludeTestData"></nz-switch>
      </div>

      <div class="filter-actions">
        <button nz-button nzType="primary" type="button" (click)="onApplyFilters()">
          {{ 'ADMIN_DASHBOARD.FILTERS.APPLY' | translate }}
        </button>
        <button nz-button nzType="default" type="button" (click)="onResetFilters()">
          {{ 'ADMIN_DASHBOARD.FILTERS.RESET' | translate }}
        </button>
      </div>
    </form>

    <div class="filter-context">
      <p>{{ 'ADMIN_DASHBOARD.FILTERS.HELPER' | translate }}</p>
      <div class="filter-context__meta">
        <span class="context-chip context-chip--period">{{ 'ADMIN_DASHBOARD.META.SELECTED_PERIOD' | translate }}</span>
        <span>{{ 'ADMIN_DASHBOARD.FILTERS.PERIOD_LABEL' | translate:{ period: selectedPeriodLabel } }}</span>
        <span>{{ 'ADMIN_DASHBOARD.FILTERS.DEFAULT_NOTE' | translate }}</span>
      </div>
    </div>
  </nz-card>

  <nz-tabset class="dashboard-tabs">
    <nz-tab [nzTitle]="'ADMIN_DASHBOARD.TABS.OVERVIEW' | translate">
      <div class="section-stack">
        <div class="section-head section-head--stacked">
          <div class="section-copy">
            <div class="section-copy__topline">
              <h2>{{ 'ADMIN_DASHBOARD.SNAPSHOT.TITLE' | translate }}</h2>
              <span class="context-chip">{{ 'ADMIN_DASHBOARD.META.LIVE_SNAPSHOT' | translate }}</span>
            </div>
            <p>{{ 'ADMIN_DASHBOARD.SNAPSHOT.SUBTITLE' | translate }}</p>
          </div>
        </div>

        <div class="kpi-grid">
          <nz-card class="kpi-card" *ngFor="let card of snapshotKpiCards" [nzLoading]="loadingOverview">
            <div class="kpi-card__title">{{ card.title | translate }}</div>
            <div class="kpi-card__value">{{ card.value }}</div>
          </nz-card>
        </div>

        <div class="kpi-grid kpi-grid--period">
          <nz-card class="kpi-card" *ngFor="let card of periodKpiCards" [nzLoading]="loadingOverview">
            <div class="kpi-card__title">{{ card.title | translate }}</div>
            <div class="kpi-card__value">{{ card.value }}</div>
          </nz-card>
        </div>
      </div>

      <div class="chart-grid">
        <nz-card class="chart-card">
          <div class="section-head">
            <h2>{{ 'ADMIN_DASHBOARD.CHARTS.CUSTOMER_GROWTH' | translate }}</h2>
          </div>
          <nz-skeleton *ngIf="loadingCharts" [nzActive]="true"></nz-skeleton>
          <div class="chart-host" *ngIf="!loadingCharts">
            <canvas baseChart [data]="customerGrowthChartData" [type]="'line'" [options]="customerGrowthChartOptions"></canvas>
          </div>
        </nz-card>

        <nz-card class="chart-card">
          <div class="section-head">
            <h2>{{ 'ADMIN_DASHBOARD.CHARTS.ARR_TREND' | translate }}</h2>
          </div>
          <nz-skeleton *ngIf="loadingCharts" [nzActive]="true"></nz-skeleton>
          <div class="chart-host" *ngIf="!loadingCharts">
            <canvas baseChart [data]="arrTrendChartData" [type]="'bar'" [options]="arrTrendChartOptions"></canvas>
          </div>
        </nz-card>
      </div>
    </nz-tab>

    <nz-tab [nzTitle]="'ADMIN_DASHBOARD.TABS.CUSTOMERS' | translate">
      <div class="section-stack">
        <div class="section-head section-head--stacked">
          <div class="section-copy">
            <div class="section-copy__topline">
              <h2>{{ 'ADMIN_DASHBOARD.ADOPTION.TITLE' | translate }}</h2>
              <span class="context-chip context-chip--mixed">{{ 'ADMIN_DASHBOARD.META.MIXED' | translate }}</span>
            </div>
            <p>{{ 'ADMIN_DASHBOARD.ADOPTION.SUBTITLE' | translate }}</p>
          </div>
        </div>

        <div class="mini-grid">
          <nz-card class="mini-card" *ngFor="let card of adoptionMiniCards" [nzLoading]="loadingOverview">
            <div class="mini-card__label">{{ card.title | translate }}</div>
            <div class="mini-card__value">{{ card.value }}</div>
          </nz-card>
        </div>

        <nz-card class="table-card">
          <nz-input-group
            [nzPrefix]="customerSearchPrefix"
            [nzSuffix]="customerSearchSuffix"
            class="table-search"
          >
            <input
              nz-input
              [placeholder]="'ADMIN_DASHBOARD.SEARCH_COMPANY' | translate"
              [(ngModel)]="customerSearch"
              (ngModelChange)="onCustomerSearchChange()"
            />
          </nz-input-group>
          <ng-template #customerSearchPrefix>
            <span nz-icon nzType="search"></span>
          </ng-template>
          <ng-template #customerSearchSuffix>
            <button
              *ngIf="customerSearch"
              nz-button
              nzType="text"
              nzSize="small"
              type="button"
              class="table-search__clear"
              [attr.aria-label]="'COMMON.CLEAR' | translate"
              (click)="clearCustomerSearch()"
            >
              <span nz-icon nzType="close-circle" nzTheme="fill"></span>
            </button>
          </ng-template>
          <nz-table
            [nzData]="companies"
            [nzFrontPagination]="false"
            [nzLoading]="loadingCompanies"
            [nzTotal]="tableTotal"
            [nzPageIndex]="tablePageIndex"
            [nzPageSize]="tablePageSize"
            [nzShowPagination]="true"
            [nzShowSizeChanger]="true"
            [nzScroll]="{ x: '1320px' }"
            (nzQueryParams)="onTableQueryParams($event)">
            <thead>
            <tr>
              <th nzColumnKey="companyName" [nzSortFn]="true">{{ 'ADMIN_DASHBOARD.TABLE.COMPANY' | translate }}</th>
              <th nzColumnKey="plan" [nzSortFn]="true">{{ 'ADMIN_DASHBOARD.TABLE.PLAN' | translate }}</th>
              <th nzColumnKey="contractStatus" [nzSortFn]="true">{{ 'ADMIN_DASHBOARD.TABLE.CONTRACT_STATUS' | translate }}</th>
              <th>{{ 'ADMIN_DASHBOARD.TABLE.NEXT_MILESTONE' | translate }}</th>
              <th nzColumnKey="onboardedPropertiesCount" [nzSortFn]="true">{{ 'ADMIN_DASHBOARD.TABLE.PROPERTIES' | translate }}</th>
              <th nzColumnKey="totalUsersCount" [nzSortFn]="true">{{ 'ADMIN_DASHBOARD.TABLE.TOTAL_USERS' | translate }}</th>
              <th nzColumnKey="lastActivityAt" [nzSortFn]="true">{{ 'ADMIN_DASHBOARD.TABLE.LAST_ACTIVITY' | translate }}</th>
              <th nzColumnKey="healthScore" [nzSortFn]="true">{{ 'ADMIN_DASHBOARD.TABLE.HEALTH' | translate }}</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let row of companies">
              <td>
                <div class="company-cell">
                  <strong>{{ row.companyName }}</strong>
                  <nz-tag *ngIf="row.isTestAccount" nzColor="gold">{{ 'ADMIN_DASHBOARD.BADGES.TEST' | translate }}</nz-tag>
                </div>
              </td>
              <td>{{ planLabel(row.plan) }}</td>
              <td><nz-tag [nzColor]="contractStatusColor(row.contractStatus)">{{ ('ADMIN_DASHBOARD.CONTRACT_STATUS.' + row.contractStatus.toUpperCase()) | translate }}</nz-tag></td>
              <td class="next-milestone-cell">{{ getNextMilestoneText(row.nextMilestone) }}</td>
              <td>{{ row.onboardedPropertiesCount }}</td>
              <td>{{ row.totalUsersCount }}</td>
              <td>{{ row.lastActivityAt ? (row.lastActivityAt | date:'short') : '—' }}</td>
              <td>
                <div class="health-cell">
                  <span class="health-score" [style.color]="healthColor(row.healthScore)">{{ row.healthScore }}</span>
                  <nz-tag [nzColor]="contractStatusColor(row.healthStatusBadge === 'Healthy' ? 'active' : (row.healthStatusBadge === 'Needs attention' ? 'missing' : 'expired'))">
                    {{ ('ADMIN_DASHBOARD.HEALTH_STATUS.' + row.healthStatusBadge.toUpperCase().replace(' ', '_')) | translate }}
                  </nz-tag>
                </div>
              </td>
              <td>
                <button nz-button nzType="link" type="button" (click)="openCompany(row)">{{ 'ADMIN_DASHBOARD.DRAWER.TITLE' | translate }}</button>
              </td>
            </tr>
            </tbody>
          </nz-table>
        </nz-card>
      </div>
    </nz-tab>

    <nz-tab [nzTitle]="'ADMIN_DASHBOARD.TABS.BILLING' | translate">
      <div class="section-stack">
        <nz-collapse nzBordered class="billing-config-collapse">
          <nz-collapse-panel
            [nzHeader]="'ADMIN_DASHBOARD.BILLING_CONFIG.TITLE' | translate"
            [nzShowArrow]="true"
          >
        <nz-card class="section-card billing-config-card" [nzLoading]="loadingBillingConfig">
          <form nz-form nzLayout="vertical" [formGroup]="billingConfigForm" class="billing-config-form">
            <div class="billing-config-section">
              <div class="billing-config-section__head">
                <h3>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.SECTIONS.PROVIDER' | translate }}</h3>
              </div>
              <div class="billing-config-grid">
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.LEGAL_NAME' | translate }}</nz-form-label>
                  <nz-form-control>
                    <input nz-input formControlName="providerLegalName" />
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item class="billing-config-grid__span-2">
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.ADDRESS' | translate }}</nz-form-label>
                  <nz-form-control>
                    <textarea nz-input formControlName="providerAddress" rows="3"></textarea>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.VAT_ID' | translate }}</nz-form-label>
                  <nz-form-control>
                    <input nz-input formControlName="providerVatId" />
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.EMAIL' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('providerEmail') || undefined">
                    <input nz-input formControlName="providerEmail" />
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.SIGNATORY_NAME' | translate }}</nz-form-label>
                  <nz-form-control>
                    <input nz-input formControlName="providerSignatoryName" />
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.SIGNATORY_ROLE' | translate }}</nz-form-label>
                  <nz-form-control>
                    <input nz-input formControlName="providerSignatoryRole" />
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.SIGNATURE_PLACE' | translate }}</nz-form-label>
                  <nz-form-control>
                    <input nz-input formControlName="providerSignaturePlace" />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div class="provider-assets-grid">
                <div class="provider-asset-card">
                  <h4>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.ASSETS.SIGNATURE_STAMP_TITLE' | translate }}</h4>
                  <p class="provider-asset-hint">{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.ASSETS.SIGNATURE_STAMP_HINT' | translate }}</p>
                  <div class="provider-asset-preview" *ngIf="providerSignatureStampPreviewUrl; else noProviderSignatureStamp">
                    <img [src]="providerSignatureStampPreviewUrl" [alt]="'ADMIN_DASHBOARD.BILLING_CONFIG.ASSETS.SIGNATURE_STAMP_TITLE' | translate" />
                  </div>
                  <ng-template #noProviderSignatureStamp>
                    <div class="provider-asset-placeholder">{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.ASSETS.NO_ASSET' | translate }}</div>
                  </ng-template>
                  <div class="provider-asset-actions">
                    <input #providerSignatureStampInput type="file" accept="image/png,image/jpeg" hidden (change)="onProviderAssetSelected($event, 'signatureStamp')" />
                    <button nz-button type="button" [nzLoading]="uploadingProviderSignatureStamp" (click)="providerSignatureStampInput.click()">
                      {{ 'ADMIN_DASHBOARD.BILLING_CONFIG.ASSETS.UPLOAD_SIGNATURE_STAMP' | translate }}
                    </button>
                    <button nz-button nzDanger type="button" *ngIf="billingConfig?.provider?.signatureStampImageConfigured" [nzLoading]="removingProviderSignatureStamp" (click)="removeProviderAsset('signatureStamp')">
                      {{ 'ADMIN_DASHBOARD.BILLING_CONFIG.ASSETS.REMOVE_SIGNATURE_STAMP' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="billing-config-section">
              <div class="billing-config-section__head">
                <h3>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.SECTIONS.BANKING' | translate }}</h3>
              </div>
              <div class="billing-config-grid">
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.BANK_ACCOUNT_HOLDER' | translate }}</nz-form-label>
                  <nz-form-control>
                    <input nz-input formControlName="bankAccountHolder" />
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.IBAN' | translate }}</nz-form-label>
                  <nz-form-control>
                    <input nz-input formControlName="iban" />
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.BIC' | translate }}</nz-form-label>
                  <nz-form-control>
                    <input nz-input formControlName="bic" />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div class="billing-config-section">
              <div class="billing-config-section__head">
                <h3>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.SECTIONS.PRICING' | translate }}</h3>
              </div>
              <div class="billing-config-grid">
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.DEFAULT_UNIT_PRICE' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('defaultUnitPriceNetYear') || undefined">
                    <nz-input-number formControlName="defaultUnitPriceNetYear" [nzMin]="0.01" [nzStep]="0.01" [nzPrecision]="2"></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.INCLUDED_USERS' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('includedUsers') || undefined">
                    <nz-input-number formControlName="includedUsers" [nzMin]="0" [nzStep]="1" [nzPrecision]="0"></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.ADDITIONAL_USER_PRICE' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('pricePerAdditionalUserNetYear') || undefined">
                    <nz-input-number formControlName="pricePerAdditionalUserNetYear" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="2"></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.VAT_RATE' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('vatRate') || undefined">
                    <nz-input-number formControlName="vatRate" [nzMin]="0" [nzMax]="1" [nzStep]="0.01" [nzPrecision]="2"></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.CURRENCY' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('currency') || undefined">
                    <nz-select formControlName="currency">
                      <nz-option nzValue="EUR" nzLabel="EUR"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.BILLING_FREQUENCY' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('billingFrequency') || undefined">
                    <nz-select formControlName="billingFrequency">
                      <nz-option *ngFor="let option of billingFrequencyOptions" [nzValue]="option" [nzLabel]="('ADMIN_DASHBOARD.BILLING_CONFIG.BILLING_FREQUENCY.' + option.toUpperCase()) | translate"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.SPECIAL_OFFER_THRESHOLD' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('specialOfferThreshold') || undefined">
                    <nz-input-number formControlName="specialOfferThreshold" [nzMin]="0" [nzStep]="1" [nzPrecision]="0"></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div class="billing-config-section">
              <div class="billing-config-section__head">
                <h3>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.SECTIONS.CONTRACT_RULES' | translate }}</h3>
              </div>
              <div class="billing-config-grid">
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.TERM_MONTHS' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('termMonths') || undefined">
                    <nz-input-number formControlName="termMonths" [nzMin]="1" [nzStep]="1" [nzPrecision]="0"></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.AUTO_RENEWAL_MONTHS' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('autoRenewalMonths') || undefined">
                    <nz-input-number formControlName="autoRenewalMonths" [nzMin]="1" [nzStep]="1" [nzPrecision]="0"></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.TERMINATION_NOTICE_MONTHS' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('terminationNoticeMonths') || undefined">
                    <nz-input-number formControlName="terminationNoticeMonths" [nzMin]="1" [nzStep]="1" [nzPrecision]="0"></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.PRICE_INCREASE_NOTICE_WEEKS' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('priceIncreaseNoticeWeeks') || undefined">
                    <nz-input-number formControlName="priceIncreaseNoticeWeeks" [nzMin]="1" [nzStep]="1" [nzPrecision]="0"></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.PAYMENT_TERM_DAYS' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('paymentTermDays') || undefined">
                    <nz-input-number formControlName="paymentTermDays" [nzMin]="0" [nzStep]="1" [nzPrecision]="0"></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.PAYMENT_DEFAULT_GRACE_DAYS' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('paymentDefaultGraceDays') || undefined">
                    <nz-input-number formControlName="paymentDefaultGraceDays" [nzMin]="0" [nzStep]="1" [nzPrecision]="0"></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.DELETION_RECOVERY_DAYS' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('deletionRecoveryDays') || undefined">
                    <nz-input-number formControlName="deletionRecoveryDays" [nzMin]="1" [nzStep]="1" [nzPrecision]="0"></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.POST_CONTRACT_EXPORT_DAYS' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('postContractExportDays') || undefined">
                    <nz-input-number formControlName="postContractExportDays" [nzMin]="1" [nzStep]="1" [nzPrecision]="0"></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.CONFIDENTIALITY_YEARS' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('confidentialityYearsAfterEnd') || undefined">
                    <nz-input-number formControlName="confidentialityYearsAfterEnd" [nzMin]="1" [nzStep]="1" [nzPrecision]="0"></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div class="billing-config-section">
              <div class="billing-config-section__head">
                <h3>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.SECTIONS.TEMPLATE' | translate }}</h3>
              </div>
              <div class="billing-config-grid">
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.TEMPLATE_LANGUAGE' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('templateLanguage') || undefined">
                    <nz-select formControlName="templateLanguage">
                      <nz-option *ngFor="let option of billingConfigLanguageOptions" [nzValue]="option" [nzLabel]="('ADMIN_DASHBOARD.BILLING_CONFIG.LANGUAGES.' + option.toUpperCase()) | translate"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.APPLICABLE_LAW' | translate }}</nz-form-label>
                  <nz-form-control>
                    <input nz-input formControlName="applicableLaw" />
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.JURISDICTION' | translate }}</nz-form-label>
                  <nz-form-control>
                    <input nz-input formControlName="jurisdiction" />
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.SUPPORT_EMAIL' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('supportEmail') || undefined">
                    <input nz-input formControlName="supportEmail" />
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.SUPPORT_PHONE' | translate }}</nz-form-label>
                  <nz-form-control>
                    <input nz-input formControlName="supportPhone" />
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING_CONFIG.FIELDS.TEMPLATE_VERSION' | translate }}</nz-form-label>
                  <nz-form-control [nzErrorTip]="billingConfigErrorTip('templateVersion') || undefined">
                    <input nz-input formControlName="templateVersion" />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div class="billing-config-actions">
              <button nz-button nzType="primary" type="button" [nzLoading]="savingBillingConfig" (click)="saveBillingConfig()">
                {{ 'ADMIN_DASHBOARD.BILLING_CONFIG.SAVE' | translate }}
              </button>
            </div>
          </form>
        </nz-card>
          </nz-collapse-panel>
        </nz-collapse>

        <div class="section-head section-head--stacked">
          <div class="section-copy">
            <div class="section-copy__topline">
              <h2>{{ 'ADMIN_DASHBOARD.BILLING_OVERVIEW.TITLE' | translate }}</h2>
              <span class="context-chip">{{ 'ADMIN_DASHBOARD.META.LIVE_SNAPSHOT' | translate }}</span>
            </div>
            <p>{{ 'ADMIN_DASHBOARD.BILLING_OVERVIEW.SUBTITLE' | translate }}</p>
          </div>
        </div>

        <div class="mini-grid mini-grid--billing">
          <nz-card class="mini-card" *ngFor="let card of billingOverviewCards" [nzLoading]="loadingContracts">
            <div class="mini-card__label">{{ card.title | translate }}</div>
            <div class="mini-card__value">{{ card.value }}</div>
          </nz-card>
        </div>

        <nz-card class="table-card" [nzLoading]="loadingContracts">
          <nz-input-group
            [nzPrefix]="billingSearchPrefix"
            [nzSuffix]="billingSearchSuffix"
            class="table-search"
          >
            <input
              nz-input
              [placeholder]="'ADMIN_DASHBOARD.SEARCH_COMPANY' | translate"
              [(ngModel)]="billingSearch"
              (ngModelChange)="onBillingSearchChange()"
            />
          </nz-input-group>
          <ng-template #billingSearchPrefix>
            <span nz-icon nzType="search"></span>
          </ng-template>
          <ng-template #billingSearchSuffix>
            <button
              *ngIf="billingSearch"
              nz-button
              nzType="text"
              nzSize="small"
              type="button"
              class="table-search__clear"
              [attr.aria-label]="'COMMON.CLEAR' | translate"
              (click)="clearBillingSearch()"
            >
              <span nz-icon nzType="close-circle" nzTheme="fill"></span>
            </button>
          </ng-template>
          <nz-table
            [nzData]="contracts?.items || []"
            [nzFrontPagination]="false"
            [nzShowPagination]="false"
            [nzScroll]="{ x: '1440px' }"
            (nzQueryParams)="onContractsTableQueryParams($event)">
            <thead>
            <tr>
              <th nzColumnKey="companyName" [nzSortFn]="true">{{ 'ADMIN_DASHBOARD.TABLE.COMPANY' | translate }}</th>
              <th nzColumnKey="plan" [nzSortFn]="true">{{ 'ADMIN_DASHBOARD.TABLE.PLAN' | translate }}</th>
              <th nzColumnKey="contractStatus" [nzSortFn]="true">{{ 'ADMIN_DASHBOARD.TABLE.CONTRACT_STATUS' | translate }}</th>
              <th nzColumnKey="latestContractYear" [nzSortFn]="true">{{ 'ACCOUNT_SETTINGS.BILLING.YEAR' | translate }}</th>
              <th nzColumnKey="latestContractStartDate" [nzSortFn]="true">{{ 'ADMIN_DASHBOARD.TABLE.CONTRACT_START' | translate }}</th>
              <th nzColumnKey="contractAmountNet" [nzSortFn]="true">{{ 'ADMIN_DASHBOARD.BILLING.NET' | translate }}</th>
              <th nzColumnKey="contractAmountGross" [nzSortFn]="true">{{ 'ADMIN_DASHBOARD.BILLING.GROSS' | translate }}</th>
              <th nzColumnKey="latestInvoiceStatus" [nzSortFn]="true">{{ 'ACCOUNT_SETTINGS.BILLING.STATUS' | translate }}</th>
              <th nzColumnKey="latestInvoiceAmountGross" [nzSortFn]="true">{{ 'ACCOUNT_SETTINGS.BILLING.AMOUNT' | translate }}</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let row of contracts?.items">
              <td>{{ row.companyName }}</td>
              <td>{{ planLabel(row.plan) }}</td>
              <td><nz-tag [nzColor]="contractStatusColor(row.contractStatus)">{{ ('ADMIN_DASHBOARD.CONTRACT_STATUS.' + row.contractStatus.toUpperCase()) | translate }}</nz-tag></td>
              <td>{{ row.latestContractYear || '—' }}</td>
              <td>{{ row.latestContractStartDate ? formatBillingDate(row.latestContractStartDate) : '—' }}</td>
              <td>{{ formatBillingAmount(row.contractAmountNet, row.contractCurrency) }}</td>
              <td>{{ formatBillingAmount(row.contractAmountGross, row.contractCurrency) }}</td>
              <td>
                <ng-container *ngIf="row.latestInvoiceStatus; else noInvoiceStatus">
                  <nz-tag [nzColor]="billingDocumentStatusColor(row.latestInvoiceStatus)">
                    {{ ('BILLING.STATUS.' + row.latestInvoiceStatus.toUpperCase()) | translate }}
                  </nz-tag>
                </ng-container>
                <ng-template #noInvoiceStatus>—</ng-template>
              </td>
              <td>{{ row.latestInvoiceId ? formatBillingAmount(row.latestInvoiceAmountGross, row.invoiceCurrency) : '—' }}</td>
              <td>
                <button nz-button nzType="link" type="button" (click)="openCompany(row)">{{ 'ADMIN_DASHBOARD.DRAWER.TITLE' | translate }}</button>
              </td>
            </tr>
            </tbody>
          </nz-table>

          <nz-pagination
            class="section-pagination"
            [nzPageIndex]="contractsPageIndex"
            [nzPageSize]="contractsPageSize"
            [nzTotal]="contracts?.total || 0"
            [nzShowSizeChanger]="true"
            [nzPageSizeOptions]="[5, 8, 12, 20]"
            (nzPageIndexChange)="onContractsPageChange($event)"
            (nzPageSizeChange)="onContractsPageSizeChange($event)">
          </nz-pagination>
        </nz-card>
      </div>
    </nz-tab>

    <nz-tab [nzTitle]="'ADMIN_DASHBOARD.TABS.USAGE' | translate">
      <div class="chart-grid">
        <nz-card class="chart-card">
          <div class="section-head">
            <h2>{{ 'ADMIN_DASHBOARD.CHARTS.PROPERTY_ONBOARDING' | translate }}</h2>
          </div>
          <nz-skeleton *ngIf="loadingCharts" [nzActive]="true"></nz-skeleton>
          <div class="chart-host" *ngIf="!loadingCharts">
            <canvas baseChart [data]="propertyTrendChartData" [type]="'line'" [options]="propertyTrendChartOptions"></canvas>
          </div>
        </nz-card>

        <nz-card class="chart-card">
          <div class="section-head">
            <h2>{{ 'ADMIN_DASHBOARD.CHARTS.PLAN_MIX' | translate }}</h2>
          </div>
          <nz-skeleton *ngIf="loadingCharts" [nzActive]="true"></nz-skeleton>
          <div class="chart-host chart-host--compact" *ngIf="!loadingCharts">
            <canvas baseChart [data]="planMixChartData" [type]="'doughnut'" [options]="planMixChartOptions"></canvas>
          </div>
        </nz-card>
      </div>

      <div class="section-stack">
        <nz-card class="section-card" [nzLoading]="loadingCharts">
          <div class="section-head section-head--stacked">
            <div class="section-copy">
              <div class="section-copy__topline">
                <h2>{{ 'ADMIN_DASHBOARD.WORKFORCE.TITLE' | translate }}</h2>
                <span class="context-chip">{{ 'ADMIN_DASHBOARD.META.LIVE_SNAPSHOT' | translate }}</span>
              </div>
              <p>{{ 'ADMIN_DASHBOARD.WORKFORCE.SUBTITLE' | translate }}</p>
            </div>
          </div>

          <div class="workforce-totals">
            <div>
              <span>{{ 'ADMIN_DASHBOARD.WORKFORCE.SERVICES' | translate }}</span>
              <strong>{{ charts?.workforceCompositionTotals?.technicalServiceCompaniesCount || 0 }}</strong>
            </div>
            <div>
              <span>{{ 'ADMIN_DASHBOARD.WORKFORCE.CARETAKERS' | translate }}</span>
              <strong>{{ charts?.workforceCompositionTotals?.caretakersCount || 0 }}</strong>
            </div>
            <div>
              <span>{{ 'ADMIN_DASHBOARD.WORKFORCE.PROPERTY_MANAGERS' | translate }}</span>
              <strong>{{ charts?.workforceCompositionTotals?.propertyManagersCount || 0 }}</strong>
            </div>
            <div>
              <span>{{ 'ADMIN_DASHBOARD.WORKFORCE.TECH_ASSET_MANAGERS' | translate }}</span>
              <strong>{{ charts?.workforceCompositionTotals?.technicalAssetManagersCount || 0 }}</strong>
            </div>
          </div>

          <div class="chart-host chart-host--compact">
            <canvas baseChart [data]="workforceChartData" [type]="'bar'" [options]="workforceChartOptions"></canvas>
          </div>
        </nz-card>
      </div>

      <div class="split-grid">
        <nz-card class="section-card">
          <div class="section-head section-head--stacked">
            <div class="section-copy">
              <div class="section-copy__topline">
                <h2>{{ 'ADMIN_DASHBOARD.FRESHNESS.TITLE' | translate }}</h2>
                <span class="context-chip context-chip--mixed">{{ 'ADMIN_DASHBOARD.META.MIXED' | translate }}</span>
              </div>
              <p>{{ 'ADMIN_DASHBOARD.FRESHNESS.SUBTITLE' | translate }}</p>
            </div>
          </div>

          <div class="freshness-grid">
            <div class="freshness-item">
              <span>{{ 'ADMIN_DASHBOARD.FRESHNESS.STALE' | translate }}</span>
              <strong>{{ overview?.stalePropertiesCount || 0 }}</strong>
              <small class="metric-note">{{ 'ADMIN_DASHBOARD.META.THRESHOLD_RULE' | translate }}</small>
            </div>
            <div class="freshness-item">
              <span>{{ 'ADMIN_DASHBOARD.FRESHNESS.RECENT' | translate }}</span>
              <strong>{{ overview?.recentlyUpdatedPropertiesCount || 0 }}</strong>
              <small class="metric-note">{{ 'ADMIN_DASHBOARD.META.SELECTED_PERIOD' | translate }}</small>
            </div>
            <div class="freshness-item">
              <span>{{ 'ADMIN_DASHBOARD.FRESHNESS.NO_SCANS' | translate }}</span>
              <strong>{{ overview?.companiesWithNoRecentScans || 0 }}</strong>
              <small class="metric-note">{{ 'ADMIN_DASHBOARD.META.ROLLING_30D' | translate }}</small>
            </div>
          </div>
        </nz-card>

        <nz-card class="section-card">
          <div class="section-head section-head--stacked">
            <div class="section-copy">
              <div class="section-copy__topline">
                <h2>{{ 'ADMIN_DASHBOARD.EMPTY.RISKS' | translate }}</h2>
              </div>
              <p>{{ 'ADMIN_DASHBOARD.ADOPTION.TABLE_NOTE' | translate }}</p>
            </div>
          </div>

          <div *ngIf="topRiskCompanies.length; else noRiskCompanies" class="risk-list">
            <div class="risk-item" *ngFor="let row of topRiskCompanies" (click)="openCompany(row)">
              <div>
                <strong>{{ row.companyName }}</strong>
                <p>{{ row.riskFlags.join(' • ') }}</p>
              </div>
              <nz-progress [nzPercent]="row.healthScore" [nzStrokeColor]="healthColor(row.healthScore)" [nzShowInfo]="false"></nz-progress>
            </div>
          </div>

          <ng-template #noRiskCompanies>
            <nz-empty [nzNotFoundContent]="'ADMIN_DASHBOARD.EMPTY.RISKS' | translate"></nz-empty>
          </ng-template>
        </nz-card>
      </div>
    </nz-tab>

    <nz-tab [nzTitle]="'ADMIN_DASHBOARD.TABS.ACTIVITY' | translate">
      <nz-card class="section-card">
        <div class="section-head section-head--stacked">
          <div class="section-copy">
            <div class="section-copy__topline">
              <h2>{{ 'ADMIN_DASHBOARD.ACTIVITY.TITLE' | translate }}</h2>
              <span class="context-chip context-chip--period">{{ 'ADMIN_DASHBOARD.META.SELECTED_PERIOD' | translate }}</span>
            </div>
            <p>{{ 'ADMIN_DASHBOARD.ACTIVITY.SUBTITLE' | translate:{ period: selectedPeriodLabel } }}</p>
          </div>
        </div>

        <nz-spin [nzSpinning]="loadingActivity">
          <div *ngIf="activity.length; else noActivity" class="activity-list">
            <div class="activity-item" *ngFor="let item of activity">
              <div class="activity-icon">
                <span nz-icon [nzType]="activityIcon(item.type)"></span>
              </div>
              <div class="activity-copy">
                <strong>{{ item.companyName }}</strong>
                <p>{{ item.description }}</p>
                <small>{{ item.actor || ('ADMIN_DASHBOARD.ACTIVITY.SYSTEM' | translate) }} • {{ item.timestamp | date:'short' }}</small>
              </div>
            </div>
          </div>

          <nz-pagination
            *ngIf="activityTotal > activityPageSize"
            class="section-pagination"
            [nzPageIndex]="activityPageIndex"
            [nzPageSize]="activityPageSize"
            [nzTotal]="activityTotal"
            [nzSimple]="true"
            (nzPageIndexChange)="onActivityPageChange($event)">
          </nz-pagination>

          <ng-template #noActivity>
            <nz-empty [nzNotFoundContent]="'ADMIN_DASHBOARD.EMPTY.ACTIVITY' | translate"></nz-empty>
          </ng-template>
              </nz-spin>
            </nz-card>
          </nz-tab>

    <nz-tab [nzTitle]="billingActionsTabTitle">

      <div class="section-stack">
        <div class="section-head">
          <div class="section-copy">
            <h2>{{ 'BILLING_ACTIONS.TITLE' | translate }}</h2>
            <p>{{ 'BILLING_ACTIONS.SUBTITLE' | translate }}</p>
          </div>
        </div>

        <div class="filter-bar">
          <nz-select [ngModel]="billingActionStatusFilter" (ngModelChange)="onBillingActionStatusFilterChange($event)" style="min-width:140px">
            <nz-option *ngFor="let s of billingActionStatusOptions" [nzValue]="s" [nzLabel]="s === 'all' ? ('BILLING_ACTIONS.FILTERS.ALL' | translate) : ('BILLING_ACTIONS.STATUS.' + s | translate)"></nz-option>
          </nz-select>
          <nz-select [ngModel]="billingActionTypeFilter" (ngModelChange)="onBillingActionTypeFilterChange($event)" style="min-width:180px">
            <nz-option nzValue="all" [nzLabel]="'BILLING_ACTIONS.FILTERS.ALL' | translate"></nz-option>
            <nz-option *ngFor="let t of billingActionTypeOptions" [nzValue]="t" [nzLabel]="'BILLING_ACTIONS.TYPES.' + t | translate"></nz-option>
          </nz-select>
          <nz-input-group [nzSuffix]="searchIcon" style="max-width:320px">
            <input nz-input [placeholder]="'BILLING_ACTIONS.FILTERS.SEARCH' | translate" [(ngModel)]="billingActionSearch" (keyup.enter)="onBillingActionSearchChange()">
          </nz-input-group>
          <ng-template #searchIcon>
            <span nz-icon nzType="search" (click)="onBillingActionSearchChange()" style="cursor:pointer"></span>
          </ng-template>
          <button nz-button nzType="default" (click)="loadBillingActions()">
            <span nz-icon nzType="reload"></span>
            {{ 'BILLING_ACTIONS.ACTIONS.REFRESH' | translate }}
          </button>
        </div>

        <nz-spin [nzSpinning]="loadingBillingActions">
          <div *ngIf="billingActions.length; else noBillingActions" class="billing-actions-list">
            <div *ngFor="let item of billingActions" class="billing-action-item">
              <div class="action-item__head">
                <nz-tag [nzColor]="getBillingActionStatusColor(item.status)">{{ getBillingActionStatusLabel(item.status) }}</nz-tag>
                <span class="action-item__type">{{ getBillingActionTypeLabel(item.type) }}</span>
                <span class="action-item__date">{{ item.createdAt | date:'medium' }}</span>
              </div>
              <div class="action-item__body">
                <div class="action-item__company" (click)="openBillingActionCompany(item)" style="cursor:pointer;color:#1890ff">
                  <span nz-icon nzType="bank"></span>
                  {{ item.snapshot.companyName || item.companyId }}
                </div>
                <div class="action-item__requester">
                  {{ item.snapshot.requesterDisplayName || item.snapshot.requesterEmail || '—' }}
                </div>
                <div class="action-item__summary">
                  {{ getBillingActionSummary(item) }}
                </div>
                <div *ngIf="item.internalNote" class="action-item__note">
                  <span nz-icon nzType="file-text"></span> {{ item.internalNote }}
                </div>
              </div>
              <div class="action-item__actions">
                <button *ngIf="item.status === 'pending'" nz-button nzType="primary" nzSize="small" (click)="handleBillingAction(item)">
                  {{ 'BILLING_ACTIONS.ACTIONS.MARK_HANDLED' | translate }}
                </button>
                <button *ngIf="item.status === 'handled' || item.status === 'dismissed'" nz-button nzType="default" nzSize="small" (click)="reopenBillingAction(item)">
                  {{ 'BILLING_ACTIONS.ACTIONS.REOPEN' | translate }}
                </button>
                <button *ngIf="item.status === 'pending'" nz-button nzType="default" nzSize="small" nzDanger (click)="dismissBillingAction(item)">
                  {{ 'BILLING_ACTIONS.ACTIONS.DISMISS' | translate }}
                </button>
                <button nz-button nzType="link" nzSize="small" (click)="openBillingActionNoteModal(item)">
                  <span nz-icon [nzType]="item.internalNote ? 'edit' : 'plus'"></span>
                  {{ item.internalNote ? ('BILLING_ACTIONS.ACTIONS.EDIT_NOTE' | translate) : ('BILLING_ACTIONS.ACTIONS.ADD_NOTE' | translate) }}
                </button>
              </div>
            </div>
          </div>

          <ng-template #noBillingActions>
            <nz-empty [nzNotFoundContent]="'BILLING_ACTIONS.EMPTY' | translate"></nz-empty>
          </ng-template>
        </nz-spin>

        <div *ngIf="billingActionsTotal > billingActionsPageSize" class="pagination-row">
          <nz-pagination
            [nzPageIndex]="billingActionsPage"
            [nzPageSize]="billingActionsPageSize"
            [nzTotal]="billingActionsTotal"
            [nzSimple]="true"
            (nzPageIndexChange)="onBillingActionPageChange($event)">
          </nz-pagination>
        </div>
      </div>
    </nz-tab>

    <nz-tab [nzTitle]="contractAlertsTabTitle">
      <app-contract-alerts
        [items]="contractAlerts"
        [loading]="loadingContractAlerts"
        (openCompany)="openContractAlertCompany($event)">
      </app-contract-alerts>
    </nz-tab>
  </nz-tabset>
</div>

<nz-drawer
  [nzVisible]="drawerVisible"
  [nzTitle]="selectedCompany?.companyName || ('ADMIN_DASHBOARD.DRAWER.TITLE' | translate)"
  [nzWidth]="720"
  (nzOnClose)="closeDrawer()">
  <ng-container *nzDrawerContent>
    <nz-spin [nzSpinning]="loadingCompanyDetail">
      <ng-container *ngIf="selectedCompany">
        <div class="drawer-head">
          <div>
            <h3>{{ selectedCompany.companyName }}</h3>
            <p>{{ selectedCompany.companySummary.domain }}</p>
          </div>
          <div class="drawer-head__actions">
            <button nz-button nzType="primary" type="button" (click)="openBillingUploadModal()" [disabled]="!isSelectedCompanyPaidPlan">
              {{ 'ADMIN_DASHBOARD.BILLING.UPLOAD' | translate }}
            </button>
          </div>
        </div>

        <nz-tabset class="drawer-tabs">
          <nz-tab [nzTitle]="'ADMIN_DASHBOARD.DRAWER_TABS.OVERVIEW' | translate">
            <nz-descriptions nzBordered [nzColumn]="1" class="drawer-descriptions">
              <nz-descriptions-item [nzTitle]="'ADMIN_DASHBOARD.TABLE.PLAN' | translate">{{ planLabel(selectedCompany.plan) }}</nz-descriptions-item>
              <nz-descriptions-item [nzTitle]="'ADMIN_DASHBOARD.TABLE.CONTRACT_STATUS' | translate">
                <nz-tag [nzColor]="contractStatusColor(selectedCompany.contractStatus)">{{ ('ADMIN_DASHBOARD.CONTRACT_STATUS.' + selectedCompany.contractStatus.toUpperCase()) | translate }}</nz-tag>
              </nz-descriptions-item>
              <nz-descriptions-item [nzTitle]="'ACCOUNT_SETTINGS.BILLING.TITLE' | translate">{{ selectedCompany.latestContractTitle || '—' }}</nz-descriptions-item>
              <nz-descriptions-item [nzTitle]="'ACCOUNT_SETTINGS.BILLING.YEAR' | translate">{{ selectedCompany.latestContractYear || '—' }}</nz-descriptions-item>
              <nz-descriptions-item [nzTitle]="'ADMIN_DASHBOARD.TABLE.CONTRACT_START' | translate">{{ selectedCompany.latestContractStartDate ? formatBillingDate(selectedCompany.latestContractStartDate) : '—' }}</nz-descriptions-item>
              <nz-descriptions-item [nzTitle]="'ADMIN_DASHBOARD.BILLING.NET' | translate">{{ formatBillingAmount(selectedCompany.contractAmountNet, selectedCompany.contractCurrency) }}</nz-descriptions-item>
              <nz-descriptions-item [nzTitle]="'ADMIN_DASHBOARD.BILLING.GROSS' | translate">{{ formatBillingAmount(selectedCompany.contractAmountGross, selectedCompany.contractCurrency) }}</nz-descriptions-item>
              <nz-descriptions-item [nzTitle]="'ADMIN_DASHBOARD.TABLE.PROPERTIES' | translate">{{ selectedCompany.onboardedPropertiesCount }}</nz-descriptions-item>
              <nz-descriptions-item [nzTitle]="'ADMIN_DASHBOARD.TABLE.TOTAL_USERS' | translate">{{ selectedCompany.totalUsersCount }}</nz-descriptions-item>
              <nz-descriptions-item [nzTitle]="'ADMIN_DASHBOARD.TABLE.SCANS' | translate">{{ selectedCompany.totalEmergencyScansInRange }}</nz-descriptions-item>
              <nz-descriptions-item [nzTitle]="'ADMIN_DASHBOARD.TABLE.TOTAL_TIME' | translate">{{ formatSeconds(selectedCompany.totalTimeSpentInRange) }}</nz-descriptions-item>
              <nz-descriptions-item [nzTitle]="'ADMIN_DASHBOARD.TABLE.LAST_ACTIVITY' | translate">{{ selectedCompany.lastActivityAt ? (selectedCompany.lastActivityAt | date:'short') : '—' }}</nz-descriptions-item>
            </nz-descriptions>

            <div class="risk-flags" *ngIf="selectedCompany.riskFlags.length">
              <h4>{{ 'ADMIN_DASHBOARD.DRAWER.RISK_FLAGS' | translate }}</h4>
              <nz-tag *ngFor="let flag of selectedCompany.riskFlags" nzColor="orange">{{ flag }}</nz-tag>
            </div>
          </nz-tab>

          <nz-tab [nzTitle]="'ADMIN_DASHBOARD.DRAWER_TABS.BILLING' | translate">
            <nz-card class="billing-section-card" [nzTitle]="'ADMIN_DASHBOARD.BILLING.TITLE' | translate">
              <p>{{ 'ADMIN_DASHBOARD.BILLING.SUBTITLE' | translate }}</p>

              <div class="pricing-panel">
                <div class="pricing-panel__head">
                  <div>
                    <h4>{{ 'ADMIN_DASHBOARD.BILLING.PRICING.CUSTOM_PRICING' | translate }}</h4>
                    <p>{{ 'ADMIN_DASHBOARD.BILLING.PRICING.DESCRIPTION' | translate }}</p>
                  </div>
                  <div class="pricing-panel__summary">
                    <span>{{ 'ADMIN_DASHBOARD.BILLING.PRICING.EFFECTIVE_PRICE' | translate }}</span>
                    <strong>{{ formatBillingAmount(selectedCompany?.effectiveUnitPrice, 'EUR') }}</strong>
                  </div>
                </div>

                <form nz-form nzLayout="vertical" [formGroup]="pricingForm">
                  <div nz-row [nzGutter]="16">
                    <div nz-col [nzXs]="24" [nzMd]="12">
                      <nz-form-item>
                        <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING.PRICING.CUSTOM_UNIT_PRICE' | translate }}</nz-form-label>
                        <nz-form-control [nzErrorTip]="'ADMIN_DASHBOARD.BILLING.PRICING.CUSTOM_UNIT_PRICE_ERROR' | translate">
                          <div class="pricing-input-row">
                            <nz-input-number
                              formControlName="customUnitPrice"
                              [nzMin]="0.01"
                              [nzStep]="0.01"
                              [nzPrecision]="2"
                              [nzPlaceHolder]="'9.99'"
                              class="w-full">
                            </nz-input-number>
                            <span class="pricing-currency">EUR</span>
                          </div>
                          <div class="pricing-field__hint">
                            {{ 'ADMIN_DASHBOARD.BILLING.PRICING.DEFAULT_PRICE_HINT' | translate }}
                          </div>
                        </nz-form-control>
                      </nz-form-item>
                    </div>

                    <div nz-col [nzXs]="24" [nzMd]="12">
                      <nz-form-item>
                        <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING.PRICING.VALIDITY_UNTIL' | translate }}</nz-form-label>
                        <nz-form-control>
                          <nz-date-picker formControlName="customUnitPriceValidityUntil" class="w-full"></nz-date-picker>
                          <div class="pricing-field__hint">
                            {{ 'ADMIN_DASHBOARD.BILLING.PRICING.VALIDITY_HINT' | translate }}
                          </div>
                        </nz-form-control>
                      </nz-form-item>
                    </div>

                    <div nz-col [nzSpan]="24">
                      <div class="pricing-actions">
                        <button
                          nz-button
                          nzType="primary"
                          type="button"
                          [nzLoading]="savingPricing"
                          (click)="saveCompanyPricing()">
                          {{ 'ADMIN_DASHBOARD.BILLING.PRICING.SAVE' | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <nz-alert
                *ngIf="!isSelectedCompanyPaidPlan"
                nzType="info"
                [nzMessage]="'ADMIN_DASHBOARD.BILLING.PAID_PLAN_ONLY' | translate"
                nzShowIcon>
              </nz-alert>

              <div class="billing-filters" *ngIf="isSelectedCompanyPaidPlan">
                <nz-select [(ngModel)]="selectedBillingYearFilter" (ngModelChange)="onBillingFiltersChange()">
                  <nz-option nzValue="all" [nzLabel]="'ADMIN_DASHBOARD.FILTERS.ALL' | translate"></nz-option>
                  <nz-option *ngFor="let year of billingYearOptions" [nzValue]="year" [nzLabel]="year + ''"></nz-option>
                </nz-select>
                <nz-select [(ngModel)]="selectedBillingTypeFilter" (ngModelChange)="onBillingFiltersChange()">
                  <nz-option nzValue="all" [nzLabel]="'ADMIN_DASHBOARD.FILTERS.ALL' | translate"></nz-option>
                  <nz-option nzValue="contract" [nzLabel]="'ACCOUNT_SETTINGS.BILLING.CONTRACT' | translate"></nz-option>
                  <nz-option nzValue="invoice" [nzLabel]="'ACCOUNT_SETTINGS.BILLING.INVOICE' | translate"></nz-option>
                </nz-select>
              </div>

              <nz-spin [nzSpinning]="loadingBillingDocuments">
                <nz-empty *ngIf="isSelectedCompanyPaidPlan && !filteredBillingDocumentsByYear.length"></nz-empty>

                <nz-collapse *ngIf="filteredBillingDocumentsByYear.length">
                  <nz-collapse-panel
                    *ngFor="let group of filteredBillingDocumentsByYear; trackBy: trackBillingDocumentGroup"
                    [nzHeader]="group.year + ''"
                    [nzActive]="group.year === filteredBillingDocumentsByYear[0]?.year">
                    <nz-list nzBordered>
                      <nz-list-item *ngFor="let document of group.documents; trackBy: trackBillingDocument" class="billing-list-item">
                        <div class="billing-list-item__content">
                          <div class="billing-list-item__header">
                            <strong class="billing-list-item__title">{{ document.title }}</strong>
                            <div class="billing-tags">
                              <nz-tag [nzColor]="document.type === 'contract' ? 'geekblue' : 'purple'">
                                {{ ('ACCOUNT_SETTINGS.BILLING.' + document.type.toUpperCase()) | translate }}
                              </nz-tag>
                              <nz-tag [nzColor]="billingDocumentStatusColor(document.status)">
                                {{ ('BILLING.STATUS.' + document.status.toUpperCase()) | translate }}
                              </nz-tag>
                            </div>
                          </div>
                          <div class="billing-list-item__details">
                            <span>{{ 'ACCOUNT_SETTINGS.BILLING.YEAR' | translate }}: {{ document.year }}</span>
                            <span *ngIf="document.documentNumber">{{ 'ACCOUNT_SETTINGS.BILLING.DOCUMENT_NUMBER' | translate }}: {{ document.documentNumber }}</span>
                            <span>{{ 'ADMIN_DASHBOARD.BILLING.NET' | translate }}: {{ formatBillingAmount(document.amountNet, document.currency) }}</span>
                            <span>{{ 'ADMIN_DASHBOARD.BILLING.GROSS' | translate }}: {{ formatBillingAmount(document.amountGross, document.currency) }}</span>
                            <span *ngIf="document.type === 'contract' && document.contractStartDate">
                              {{ 'ADMIN_DASHBOARD.TABLE.CONTRACT_START' | translate }}: {{ formatBillingDate(document.contractStartDate) }}
                            </span>
                            <span *ngIf="document.type === 'invoice' && document.issueDate">
                              {{ 'ACCOUNT_SETTINGS.BILLING.ISSUE_DATE' | translate }}: {{ formatBillingDate(document.issueDate) }}
                            </span>
                            <span *ngIf="document.type === 'invoice' && document.dueDate">
                              {{ 'ACCOUNT_SETTINGS.BILLING.DUE_DATE' | translate }}: {{ formatBillingDate(document.dueDate) }}
                            </span>
                            <span *ngIf="document.fileName" class="billing-list-item__file-name">{{ document.fileName }}</span>
                            <span *ngIf="document.migratedWithoutFile || !document.hasFile">{{ 'ADMIN_DASHBOARD.BILLING.NO_FILE' | translate }}</span>
                          </div>
                        </div>
                        <div class="billing-list-item__actions">
                          <button
                            nz-button
                            nzType="default"
                            nzShape="circle"
                            type="button"
                            [attr.aria-label]="'ADMIN_DASHBOARD.BILLING.EDIT' | translate"
                            [title]="'ADMIN_DASHBOARD.BILLING.EDIT' | translate"
                            (click)="openBillingEditModal(document)">
                            <span nz-icon nzType="edit"></span>
                          </button>
                          <button
                            nz-button
                            nzType="default"
                            nzShape="circle"
                            type="button"
                            [disabled]="document.migratedWithoutFile || !document.hasFile"
                            [attr.aria-label]="'ADMIN_DASHBOARD.BILLING.DOWNLOAD' | translate"
                            [title]="'ADMIN_DASHBOARD.BILLING.DOWNLOAD' | translate"
                            (click)="downloadBillingDocument(document)">
                            <span nz-icon nzType="download"></span>
                          </button>
                          <button
                            nz-button
                            nzDanger
                            nzShape="circle"
                            type="button"
                            [attr.aria-label]="'ADMIN_DASHBOARD.BILLING.ARCHIVE' | translate"
                            [title]="'ADMIN_DASHBOARD.BILLING.ARCHIVE' | translate"
                            (click)="archiveBillingDocument(document)">
                            <span nz-icon nzType="delete"></span>
                          </button>
                        </div>
                      </nz-list-item>
                    </nz-list>
                  </nz-collapse-panel>
                </nz-collapse>
              </nz-spin>
            </nz-card>

            <nz-card *ngIf="drawerBillingActions.length || loadingDrawerBillingActions" class="billing-section-card" [nzTitle]="'BILLING_ACTIONS.COMPANY_SECTION_TITLE' | translate">
              <nz-spin [nzSpinning]="loadingDrawerBillingActions">
                <div class="drawer-billing-actions-list">
                  <div *ngFor="let item of drawerBillingActions" class="drawer-billing-action-item">
                    <div class="drawer-action-item__head">
                      <nz-tag [nzColor]="getBillingActionStatusColor(item.status)">{{ getBillingActionStatusLabel(item.status) }}</nz-tag>
                      <span>{{ getBillingActionTypeLabel(item.type) }}</span>
                      <span>{{ item.createdAt | date:'short' }}</span>
                    </div>
                    <div>{{ getBillingActionSummary(item) }}</div>
                    <div *ngIf="item.internalNote" style="color:#8c8c8c;font-style:italic"><span nz-icon nzType="file-text"></span> {{ item.internalNote }}</div>
                  </div>
                </div>
              </nz-spin>
            </nz-card>
          </nz-tab>

          <nz-tab [nzTitle]="'ADMIN_DASHBOARD.DRAWER_TABS.CONTRACT_TIMELINE' | translate">
            <app-contract-timeline
              [timeline]="selectedCompanyTimeline"
              [loading]="loadingContractTimeline">
            </app-contract-timeline>
          </nz-tab>

          <nz-tab [nzTitle]="'ADMIN_DASHBOARD.DRAWER_TABS.USAGE' | translate">
            <div class="drawer-period-label">
              <span class="context-chip context-chip--period">{{ 'ADMIN_DASHBOARD.META.SELECTED_PERIOD' | translate }}</span>
              <span>{{ 'ADMIN_DASHBOARD.DRAWER.PERIOD' | translate:{ period: selectedPeriodLabel } }}</span>
            </div>

            <div class="drawer-chart-grid">
              <nz-card>
                <div class="chart-host chart-host--drawer">
                  <canvas baseChart [data]="detailScansChartData" [type]="'line'" [options]="detailScansChartOptions"></canvas>
                </div>
              </nz-card>
              <nz-card>
                <div class="chart-host chart-host--drawer">
                  <canvas baseChart [data]="detailTimeChartData" [type]="'line'" [options]="detailTimeChartOptions"></canvas>
                </div>
              </nz-card>
            </div>
          </nz-tab>

          <nz-tab [nzTitle]="'ADMIN_DASHBOARD.DRAWER_TABS.HISTORY' | translate">
            <nz-card class="billing-section-card" [nzTitle]="'ADMIN_DASHBOARD.BILLING.HISTORY_TITLE' | translate">
              <nz-spin [nzSpinning]="loadingBillingHistory">
                <div *ngIf="billingHistory.length; else noBillingHistory" class="history-list">
                  <div *ngFor="let item of billingHistory" class="history-item">
                    <div class="history-item__head">
                      <strong>{{ item.documentTitle || '—' }}</strong>
                      <span>{{ item.timestamp | date:'short' }}</span>
                    </div>
                    <div class="history-item__meta">
                      <span>{{ item.description }}</span>
                      <span *ngIf="item.actorName || item.actorEmail">{{ item.actorName || item.actorEmail }}</span>
                      <span *ngIf="item.year">{{ 'ACCOUNT_SETTINGS.BILLING.YEAR' | translate }}: {{ item.year }}</span>
                    </div>
                    <div class="history-item__changes" *ngIf="getHistoryChangeEntries(item.changes).length">
                      <div *ngFor="let change of getHistoryChangeEntries(item.changes)">
                        <strong>{{ formatHistoryFieldLabel(change.key) }}</strong>:
                        {{ 'ADMIN_DASHBOARD.BILLING.CHANGED_FROM_TO' | translate:{ from: formatHistoryValue(change.from), to: formatHistoryValue(change.to) } }}
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #noBillingHistory>
                  <nz-empty [nzNotFoundContent]="'ADMIN_DASHBOARD.BILLING.NO_HISTORY' | translate"></nz-empty>
                </ng-template>
              </nz-spin>
            </nz-card>
          </nz-tab>
        </nz-tabset>
      </ng-container>
    </nz-spin>
  </ng-container>
</nz-drawer>

<nz-modal
  [nzVisible]="billingModalVisible"
  [nzTitle]="(editingBillingDocument ? 'ADMIN_DASHBOARD.BILLING.EDIT' : 'ADMIN_DASHBOARD.BILLING.UPLOAD') | translate"
  [nzOkLoading]="savingBillingDocument"
  [nzOkText]="'COMMON.SAVE' | translate"
  [nzCancelText]="'ADMIN_DASHBOARD.CONTRACT.CANCEL' | translate"
  (nzOnCancel)="closeBillingModal()"
  (nzOnOk)="saveBillingDocument()">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="billingForm">
      <div nz-row [nzGutter]="12">
        <div nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label>{{ 'ACCOUNT_SETTINGS.BILLING.CONTRACT' | translate }}/{{ 'ACCOUNT_SETTINGS.BILLING.INVOICE' | translate }}</nz-form-label>
            <nz-form-control>
              <nz-select formControlName="type">
                <nz-option nzValue="contract" [nzLabel]="'ACCOUNT_SETTINGS.BILLING.CONTRACT' | translate"></nz-option>
                <nz-option nzValue="invoice" [nzLabel]="'ACCOUNT_SETTINGS.BILLING.INVOICE' | translate"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label>{{ 'ACCOUNT_SETTINGS.BILLING.YEAR' | translate }}</nz-form-label>
            <nz-form-control>
              <nz-input-number formControlName="year" [nzMin]="2000" [nzMax]="3000" class="w-full"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label>{{ 'ACCOUNT_SETTINGS.BILLING.TITLE' | translate }}</nz-form-label>
            <nz-form-control>
              <input nz-input formControlName="title" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label>{{ 'ACCOUNT_SETTINGS.BILLING.DOCUMENT_NUMBER' | translate }}</nz-form-label>
            <nz-form-control>
              <input nz-input formControlName="documentNumber" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label>{{ 'ACCOUNT_SETTINGS.BILLING.STATUS' | translate }}</nz-form-label>
            <nz-form-control>
              <nz-select formControlName="status">
                <nz-option *ngFor="let status of billingStatusOptions" [nzValue]="status" [nzLabel]="('BILLING.STATUS.' + status.toUpperCase()) | translate"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="12" *ngIf="isBillingInvoiceType">
          <nz-form-item>
            <nz-form-label>{{ 'ACCOUNT_SETTINGS.BILLING.ISSUE_DATE' | translate }}</nz-form-label>
            <nz-form-control><nz-date-picker formControlName="issueDate"></nz-date-picker></nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="12" *ngIf="isBillingInvoiceType">
          <nz-form-item>
            <nz-form-label>{{ 'ACCOUNT_SETTINGS.BILLING.DUE_DATE' | translate }}</nz-form-label>
            <nz-form-control><nz-date-picker formControlName="dueDate"></nz-date-picker></nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="12" *ngIf="isBillingContractType">
          <nz-form-item>
            <nz-form-label>{{ 'ADMIN_DASHBOARD.TABLE.CONTRACT_START' | translate }}</nz-form-label>
            <nz-form-control><nz-date-picker formControlName="contractStartDate"></nz-date-picker></nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="8">
          <nz-form-item>
            <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING.NET' | translate }}</nz-form-label>
            <nz-form-control [nzErrorTip]="billingAmountErrorTpl">
              <input nz-input formControlName="amountNet" inputmode="decimal" class="w-full" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="8">
          <nz-form-item>
            <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING.GROSS' | translate }}</nz-form-label>
            <nz-form-control [nzErrorTip]="billingAmountErrorTpl">
              <input nz-input formControlName="amountGross" inputmode="decimal" class="w-full" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="8">
          <nz-form-item>
            <nz-form-label>{{ 'ADMIN_DASHBOARD.CONTRACT.CURRENCY' | translate }}</nz-form-label>
            <nz-form-control><input nz-input formControlName="currency" /></nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label>{{ 'ADMIN_DASHBOARD.BILLING.FILE' | translate }} <span class="field-hint--optional">{{ 'ADMIN_DASHBOARD.BILLING.FILE_OPTIONAL' | translate }}</span></nz-form-label>
            <nz-form-control>
              <input type="file" accept="application/pdf,image/*" (change)="onBillingFileSelected($event)" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label>{{ 'ADMIN_DASHBOARD.CONTRACT.NOTES' | translate }}</nz-form-label>
            <nz-form-control><textarea nz-input rows="3" formControlName="notes"></textarea></nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>
    <ng-template #billingAmountErrorTpl>
      {{ 'ADMIN_DASHBOARD.BILLING.INVALID_AMOUNT' | translate }}
    </ng-template>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="noteModalVisible"
  [nzTitle]="noteActionItem?.internalNote ? ('BILLING_ACTIONS.ACTIONS.EDIT_NOTE' | translate) : ('BILLING_ACTIONS.ACTIONS.ADD_NOTE' | translate)"
  [nzOkText]="'SAVE' | translate"
  [nzCancelText]="'CANCEL' | translate"
  (nzOnOk)="saveBillingActionNote()"
  (nzOnCancel)="closeNoteModal()">
  <ng-container *nzModalContent>
    <textarea
      nz-input
      [(ngModel)]="noteText"
      [placeholder]="'BILLING_ACTIONS.NOTE.PLACEHOLDER' | translate"
      [nzAutosize]="{ minRows: 3, maxRows: 8 }"
      [maxlength]="2000"
      style="width:100%">
    </textarea>
    <div style="color:#8c8c8c;font-size:12px;margin-top:4px">{{ (noteText?.length || 0) }}/2000</div>
  </ng-container>
</nz-modal>
